// -*- Mode: rjsx -*-
import React, { useState}  from 'react';
import axios from 'axios';

import Morty from '../data/Morty';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import makeStyles from '@mui/styles/makeStyles';

// import Avatar from '@mui/material/Avatar';
import { Fade,
         Avatar,
         Grid,
         Link,
         Paper,
         Typography,
         Box,
         Button,
         TextField
       }
from '@mui/material';





const useStyles = makeStyles((theme) => ({
    avatarHolder: {
        margin: theme.spacing(1, 1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
        height: theme.spacing(7),
        width: theme.spacing(7),        
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    button: {
        margin: theme.spacing(2, 0, 2),        
    },
    errors: {
        h2: { color: "red", paddingBottom: 0, marginBottom: 0 },
        h3: { color: "red" },        
    }
}));


function SignInButton(props) {
    const classes = useStyles();

    if(props.sending) {
        return (
            <Button
              className={classes.button}
              type="submit"
              fullWidth
              variant="contained"
              disabled
              startIcon={<SyncIcon />}              
              >
              Working
            </Button>
        );
    }
    return (
        <Button
          className={classes.button}
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<LockOutlinedIcon />}
        >
          Sign In
        </Button>
    );

}

// class PasswordChange extends React.Component {
function PasswordChange() {

    const [errors, setErrors] = useState([]);
    const [password, setPassword] = useState('');    
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);

    const handleSubmit = (event) => {

        event.preventDefault();
        
        setSending(true);
        setErrors([]);
        

        let payload = {
            password: password,
            email: email
        };
        
	    Morty
            .post('/morty/auth/password/', payload)
            .then((data) => {
                
                // FIXME: should go to send_to if we can.
                
                if(data.user.type == 'Client')
                    window.location.href = '/dashboard';
                else 
                    window.location.href = '/admin';                
            }).
            catch((data) => {
                setErrors(["Can't Sign In", "Check your password and try again."]);
                setSending(false);                
            });
        
        console.log("gotta set password.");
        
    };

    const togglePasswordReset = (event) => {
//        event.preventDefault();
    };
    
    const handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if(name == 'email')
            setEmail(value);
        else if(name == 'password')
            setPassword(value);

    };

    const classes = useStyles();
    let errorDisplay = null;
    
    if(errors.length) {
        errorDisplay = (
            <Fade in={true}>
            <div >
              <h2 style={classes.errors.h2}>{ errors[0] }</h2>
              <h3 style={classes.errors.h3}>{ errors[1] }</h3>
            </div>
            </Fade>
        );
    }
    
	return (
        <div>
          
		  <form onSubmit={handleSubmit} noValidate>

            <div className={classes.avatarHolder}>
            
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
              </Avatar>
            </div>
            
            {errorDisplay}

            <TextField
              onChange={handleChange}
              value={email}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />


            <TextField
              onChange={handleChange}
              value={password}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />

            <SignInButton sending={sending} />

            <Grid container>
              <Grid item xs>
                <Link href={"/password/reset" + (email ? "?email=" + encodeURI(email) : '')}  variant="body2">
                  Reset your password?
                </Link>
              </Grid>
            </Grid>            

            <Grid container>
              <Grid item xs>
                <Box borderTop={1} borderColor="grey.200" m={2} p={2}>
                <Typography variant="body2" align="center" color="textSecondary">
                  Never had a password? <br /> <Link href="/password/reset" variant="body2" >We'll get you set up.</Link>
                </Typography>
                </Box>
              </Grid>
            </Grid>            
            
            
          </form>
        </div>
	);
}


export default PasswordChange;
